<template>
    <div style="width: 100%;"> 
        <div class="bonus-buttons">
            <a class="button secondary bonus-request-btn" data-title="Bonus Al" @click="bonus_modal = true;type = 'bonus'" href="javascript:;">
                <img src="@/assets/images/common/icons/bonus.gif" width="18">
                <span> Bonus <br> Alın</span>
            </a>
            <a  class="button secondary discount-request-btn" data-title="Discount Al" @click="bonus_modal = true;type = 'discount'" href="javascript:;">
                <img src="@/assets/images/common/icons/discount.gif" width="18">
                Discount <br> Alın
            </a>
            <promoCode v-if="isMobile"></promoCode>
        </div>
        <div class="bonus-modal">
            <Modal :isVisible="bonus_modal">
                <template slot="content">
                    <div class="close-btn button primary" @click="bonus_modal = false;type = ''">
                                <svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
                    </div>
                    <component is="RequestPage" :propType="type" />
                </template>
            </Modal>
        </div>
    </div>
</template>
<script>
  import promoCode from './promoCode';
import RequestPage from './Request.vue'
  export default{
    data(){
        return{
            type: '',
            bonus_modal: false,
        }
    },
    components:{
        promoCode,
        RequestPage
    },
    watch:{
        bonus_modal(val){
            if(val){
            document.querySelector("#app").classList.add('lock');
            }else{
            document.querySelector("#app").classList.remove('lock');
            }
        }
    },
  }
</script>
